import { type $CountersinkHole, Handing, radiusToSegmentCount } from 'metalworks-domain'
import { CylinderGeometry, type MeshStandardMaterial } from 'three'
import { Brush } from 'three-bvh-csg'

const sqrt4 = Math.sqrt(4)

export const createCountersinkHoleMesh = (
  hole: Pick<$CountersinkHole, '$absCoords' | 'topRadius' | 'bottomRadius'>,
  thickness: number,
  handing: Handing,
  material: MeshStandardMaterial
) => {
  const {
    $absCoords: { x, y },
    topRadius,
    bottomRadius,
  } = hole

  const height = (2 * (topRadius - bottomRadius)) / sqrt4
  const xRotation = handing === Handing.reverse ? -Math.PI / 2 : Math.PI / 2
  const zOffset = handing === Handing.reverse ? 0 : thickness

  const geometry = new CylinderGeometry(topRadius, bottomRadius, height, radiusToSegmentCount(topRadius))
    .rotateX(xRotation)
    .translate(0, 0, zOffset)

  const mesh = new Brush(geometry, material)

  mesh.position.set(x, y, 0)
  mesh.updateMatrixWorld()

  return mesh
}
